module.exports = __webpack_public_path__ + "static/marianne-48a92807308f296dc83c31c6b376cacd.png";